import { FocusOn } from 'react-focus-on';
import { breakpoints } from '@ui/css';
import { Overlay } from '@ui/kit';
import { ToolboxIcon } from '@ui/kit/icons';
import { useMatchBreakpoint } from '@utils/react';
import { containerCls, headingCls, headingIconCls, listCls, listItemCls, closeButtonCls } from './atom.dropdown.style.js';
import { ToolLink } from './atom.link.js';
import { jsx, jsxs } from 'react/jsx-runtime';

const ToolboxDropdown = ({
  id,
  tools,
  buttonRef,
  dropdownRef,
  open,
  onClose
}) => {
  const isMobile = useMatchBreakpoint(breakpoints.mobile);
  return /*#__PURE__*/jsx(Overlay, {
    active: open,
    containerRef: buttonRef,
    placement: isMobile ? "top" : "left",
    offsetPx: 18,
    children: /*#__PURE__*/jsx(FocusOn, {
      enabled: open,
      onEscapeKey: onClose,
      onClickOutside: onClose,
      scrollLock: false,
      focusLock: true,
      autoFocus: true,
      noIsolation: true,
      allowPinchZoom: true,
      returnFocus: {
        preventScroll: true
      },
      preventScrollOnFocus: true,
      shards: buttonRef.current ? [buttonRef.current] : undefined,
      children: /*#__PURE__*/jsxs("div", {
        ref: dropdownRef,
        className: containerCls,
        id: id,
        children: [/*#__PURE__*/jsxs("h6", {
          className: headingCls,
          children: [/*#__PURE__*/jsx(ToolboxIcon, {
            className: headingIconCls,
            height: 22
          }), "V\xE6rkt\xF8jer"]
        }), /*#__PURE__*/jsx("ul", {
          className: listCls,
          children: tools.map((tool, index) => /*#__PURE__*/jsx("li", {
            className: listItemCls,
            children: /*#__PURE__*/jsx(ToolLink, {
              tool: tool,
              onClick: onClose
            })
          }, index))
        }), /*#__PURE__*/jsx("button", {
          className: closeButtonCls,
          onClick: onClose,
          "aria-label": "Luk panelet",
          children: /*#__PURE__*/jsx("span", {})
        })]
      })
    })
  });
};

export { ToolboxDropdown };
//# sourceMappingURL=atom.dropdown.js.map
